import React, { useEffect, useState } from 'react';
import { Input, message, Spin } from 'antd'; // Import Ant Design Input and Spin for the search bar and loading
import axios from 'axios';
import { MathJax, MathJaxContext } from 'better-react-mathjax'; // Import MathJax for LaTeX rendering

const { Search } = Input;

const MetadataList = () => {
  const [metadata, setMetadata] = useState([]);
  const [filteredMetadata, setFilteredMetadata] = useState([]); // State for filtered results
  const [loading, setLoading] = useState(true); // State for loading
  const [flippedCards, setFlippedCards] = useState({}); // State to track flipped cards

  useEffect(() => {
    const fetchMetadata = async () => {
      setLoading(true); // Set loading to true at the start
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/metadata/`);
        setMetadata(response.data);
        setFilteredMetadata(response.data); // Initialize filtered data with full dataset
      } catch (error) {
        message.error('Failed to fetch metadata');
        console.error('Error fetching metadata:', error);
      } finally {
        setLoading(false); // Set loading to false when the request completes
      }
    };

    fetchMetadata();
  }, []);

  const handleSearch = (value) => {
    const searchValue = value.toLowerCase();
    const filtered = metadata.filter(
      (item) =>
        item.name.toLowerCase().includes(searchValue) ||
        item.short_name.toLowerCase().includes(searchValue)
    );
    setFilteredMetadata(filtered);
  };

  const toggleFreeze = (id) => {
    setFlippedCards((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle freeze state for the clicked card
    }));
  };

  return (
    <div>
      {/* Search Bar */}
      <Search
        placeholder="Search by name or short name"
        onSearch={handleSearch}
        allowClear
        style={{ marginBottom: '30px', width: '100%', maxWidth: '600px', display: 'block', margin: '0 auto' }}
      />

      {loading ? (
        // Display a centered loading spinner while loading
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <Spin size="large" />
        </div>
      ) : (
        <MathJaxContext>
          <div className="metadata-list-container">
            {filteredMetadata.map((item) => (
              <div
                key={item.id}
                className={`metadata-card-container ${flippedCards[item.id] ? 'frozen' : ''}`} // Apply 'frozen' class if card is frozen
                onClick={() => toggleFreeze(item.id)}
              >
                <div className="metadata-card">
                  {/* Front Side of the Card */}
                  <div className="metadata-card-front">
                    <h3>{item.name}</h3>
                    <p>({item.short_name})</p>
                  </div>

                  {/* Back Side of the Card */}
                  <div className="metadata-card-back">
                    <p>{item.description}</p>
                    {item.formula_plaintext && (
                      <>
                        <MathJax style={{ fontSize: '0.8em', lineHeight: '1.2' }}>
                          {`\\[ ${item.formula_plaintext} \\]`} {/* Wrap the formula in LaTeX delimiters */}
                        </MathJax>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </MathJaxContext>
      )}
    </div>
  );
};

export default MetadataList;
